(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ifu-category-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ifu-category-banner')) {
    customElements.define('ifu-category-banner', class extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('.ifu-banner__viewport');
        this.slides = [...this.querySelectorAll('.ifu-banner__slide')];
        if (this.slides.length < 2) return;
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.motion.matches;
        this.index = 0;
        this.hovered = false;
        this.focused = false;
        this.visible = true;
        this.querySelector('.ifu-banner__controls').hidden = false;
        this.querySelectorAll('[data-direction]').forEach(button => button.addEventListener('click', () => this.go(this.index + Number(button.dataset.direction), true), { signal }));
        this.querySelector('[data-toggle]').addEventListener('click', () => { this.paused = !this.paused; this.renderToggle(); this.schedule(); }, { signal });
        this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; this.schedule(); } }, { signal });
        this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, { signal });
        this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, { signal });
        this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) { this.focused = false; this.schedule(); } }, { signal });
        this.addEventListener('keydown', event => { if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1), true); } }, { signal });
        this.viewport.addEventListener('pointerdown', () => { clearTimeout(this.timer); }, { signal });
        this.viewport.addEventListener('pointerup', () => this.schedule(), { signal });
        this.viewport.addEventListener('pointercancel', () => this.schedule(), { signal });
        this.viewport.addEventListener('scroll', () => {
          clearTimeout(this.settle);
          clearTimeout(this.timer);
          this.settle = setTimeout(() => { this.index = Math.round(this.viewport.scrollLeft / this.viewport.clientWidth); this.update(); this.schedule(); }, 120);
        }, { signal, passive:true });
        document.addEventListener('visibilitychange', () => this.schedule(), { signal });
        this.motion.addEventListener('change', () => { this.paused = this.motion.matches; this.renderToggle(); this.schedule(); }, { signal });
        this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.schedule(); }, { threshold:0.1 });
        this.observer.observe(this);
        this.resize = new ResizeObserver(() => { this.viewport.scrollTo({ left:this.index * this.viewport.clientWidth, behavior:'instant' }); });
        this.resize.observe(this.viewport);
        document.addEventListener('shopify:block:select', event => { const selected = this.slides.indexOf(event.target); if (selected >= 0) { this.paused = true; this.renderToggle(); this.go(selected, true); } }, { signal });
        this.update();
        this.renderToggle();
        this.schedule();
      }
      renderToggle() {
        const text = this.paused ? this.dataset.play : this.dataset.pause;
        this.querySelector('[data-toggle]').setAttribute('aria-label', text);
        this.querySelector('[data-toggle-text]').textContent = text;
      }
      update() {
        this.index = Math.max(0, Math.min(this.index, this.slides.length - 1));
        this.querySelector('[data-current]').textContent = this.index + 1;
        this.slides.forEach((slide, index) => { slide.inert = index !== this.index; slide.setAttribute('aria-hidden', String(index !== this.index)); });
      }
      go(index, manual = false) {
        clearTimeout(this.timer);
        this.index = (index + this.slides.length) % this.slides.length;
        this.viewport.scrollTo({ left:this.index * this.viewport.clientWidth, behavior:this.motion.matches ? 'instant' : 'smooth' });
        if (manual) this.querySelector('.ifu-banner__status').textContent = this.slides[this.index].dataset.title;
        this.update();
        this.schedule();
      }
      schedule() {
        clearTimeout(this.timer);
        if (!this.paused && !this.hovered && !this.focused && this.visible && !document.hidden) this.timer = setTimeout(() => this.go(this.index + 1), Number(this.dataset.interval));
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        this.resize?.disconnect();
        clearTimeout(this.timer);
        clearTimeout(this.settle);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
